import { TrackedChangeType } from 'prose-core'
import {
  TrackedChangeAdded,
  TrackedChangeDeleted,
  TrackedChangeFormatted,
  TrackedChangeReplaced,
} from 'almanac-ui/icons'

export const VERBS = {
  [TrackedChangeType.Insertion]: 'added',
  [TrackedChangeType.Deletion]: 'deleted',
  [TrackedChangeType.FormattingChange]: 'formatted',
  [TrackedChangeType.NodeTypeChange]: 'replaced',
}

export const ICONS = {
  [TrackedChangeType.Insertion]: TrackedChangeAdded,
  [TrackedChangeType.Deletion]: TrackedChangeDeleted,
  [TrackedChangeType.FormattingChange]: TrackedChangeFormatted,
  [TrackedChangeType.NodeTypeChange]: TrackedChangeReplaced,
}
